// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + {"285":"app-messages-fr_CA","294":"app-messages-en_US","496":"app-messages-any_Ext","546":"app-messages-en_CA","586":"product-metadata"}[chunkId] + "." + {"285":"3f3bf42d","294":"80900406","496":"c0c3418b","546":"e3312488","586":"eb61da2e"}[chunkId] + ".chunk.js";
};